import React from 'react';
import {Col, Row} from 'antd';
import InputFormField from '../data_entry/form/InputFormField';

const passwordRules = [
    {required: true, message: 'Informe a senha'},
    {min: 8, message: 'A senha deve ter no mínimo 8 caracteres'},
    {
        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]/,
        message: 'A senha deve conter letras maiúsculas, minúsculas, números e caracteres especiais (@$!%*?&#)'
    }
];

export default function PasswordFields({form, required = true}) {
    const rules = required ? passwordRules : [
        ...passwordRules.slice(1),
        {required: false}
    ];

    return (
        <Row gutter={[16, 0]}>
            <Col xs={24} lg={12}>
                <InputFormField
                    type="password"
                    placeholder="Digite a senha"
                    form={{
                        label: "Senha",
                        name: "password",
                        rules: rules
                    }}
                />
            </Col>
            <Col xs={24} lg={12}>
                <InputFormField
                    type="password"
                    placeholder="Confirme a senha"
                    form={{
                        label: "Confirmar Senha",
                        name: "confirm_password",
                        dependencies: ['password'],
                        rules: [
                            {required: required, message: 'Confirme a senha'},
                            ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('password') === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error('As senhas não conferem'));
                                },
                            }),
                        ]
                    }}
                />
            </Col>
        </Row>
    );
}

export {passwordRules};